import alt from '../alt';
import modalAction from '../actions/modalAction';

class modalStore {
    constructor() {
        this.bindActions(modalAction);
        this.title="";
        this.content="";
        this.modalClose="";
    }

    onModalClose(data) {
        this.modalClose = data;
    }
    onModalContent(data){
        this.title = data.title;
        this.content = data.content;
    }
}
export default alt.createStore(modalStore, 'modalStore');


// WEBPACK FOOTER //
// ./app/stores/modalStore.js